export enum NoteActivityType {
	exercise = 'exercise',
	daily_challenge = 'daily_challenge',
	quiz = 'quiz',
	tip_of_the_week = 'tip_of_the_week'
}
